import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import UserRepository from "../../../core/repository/UserRepository";
import WaterMark from "@uiw/react-watermark";

const ImageDocumentView = ({ filePath, fileName }) => {
  const [userInfo, setUserInfo] = useState({ name: "", contact: "", email: "" });

  useEffect(() => {
    const getUser = async () => {
      const user = await UserRepository.getUserDetail();
      setUserInfo({
        name: `${user?.data?.first_name || ""} ${user?.data?.last_name || ""}`.trim(),
        contact: user?.data?.phone_number || "",
        email: user?.data?.email || "",
      });
    };
    getUser();
  }, []);

  return (
    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 4, padding: 2, mt: 2 }}>
      <Typography
        sx={{ textAlign: "center", fontSize: 18, fontWeight: 700, mb: 2 }}
      >
        {fileName?.replace(/\.[^/.]+$/, "")}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <WaterMark
          content={[userInfo.name, userInfo.contact, userInfo.email]}
          gap={[120, 120]}
          fontSize={12}
          rotate={-20}
          fontColor="rgba(0, 0, 0, 0.25)"
        >
          <Box
            component="img"
            src={filePath}
            alt={fileName || "Document"}
            sx={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              borderRadius: 2,
              border: "1px solid #e0e0e0",
            }}
          />
        </WaterMark>
      </Box>
    </Box>
  );
};

export default ImageDocumentView;